import CanonicalNameService from "./CanonicalNameService";

type HasName = {
    name: string;
};

const getIdFromName = ({ name }: HasName) => CanonicalNameService.getCanonicalName(name);

export default getIdFromName;
